import React from 'react';

/**
 * The BondHQ mark: an arc reactor drawn in SVG, coloured by currentColor
 * (which .arc-reactor sets to var(--hud-accent)). Static by default.
 *
 *   <ArcReactor size={32} />                  decorative mark
 *   <ArcReactor size={32} title="BondHQ" />   labelled image
 *   <ArcReactor spinning />                   loader — segment ring rotates
 *   <ArcReactor booting />                    one spin-up on mount (login)
 *
 * Motion lives entirely in CSS, so prefers-reduced-motion (index.css) stops it.
 */
export default function ArcReactor({
  size = 32, spinning = false, booting = false, title, className = '', style,
}) {
  const classes = ['arc-reactor', spinning && 'is-spinning', booting && 'is-booting', className]
    .filter(Boolean).join(' ');
  const a11y = title ? { role: 'img', 'aria-label': title } : { 'aria-hidden': true, focusable: 'false' };
  return (
    <svg
      className={classes}
      width={size}
      height={size}
      viewBox="0 0 64 64"
      fill="none"
      style={style}
      {...a11y}
    >
      <circle className="arc-outer" cx="32" cy="32" r="29" strokeWidth="2" />
      <g className="arc-seg">
        {/* 10 coils: circumference 2π·22 ≈ 138.2 → 10 × (10 + 3.82) */}
        <circle cx="32" cy="32" r="22" strokeWidth="6" strokeDasharray="10 3.82" />
      </g>
      <circle className="arc-inner" cx="32" cy="32" r="14" strokeWidth="1.5" />
      <circle className="arc-core" cx="32" cy="32" r="9" opacity="0.4" />
      <circle className="arc-core-hot" cx="32" cy="32" r="4.5" />
    </svg>
  );
}

/** Centered spinner + label, for whole-panel loading states. */
export function ArcLoader({ label = 'Loading…', size = 40 }) {
  return (
    <div className="arc-loader" role="status">
      <ArcReactor size={size} spinning />
      <span className="hud-label">{label}</span>
    </div>
  );
}
